import { Injectable, Pipe, PipeTransform } from '@angular/core';
import {
  CategoryOpenSearch,
  CategoryOpenSearchClass,
} from '../enums/category-open-search';
@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'classCategoryOpenSearch',
  pure: true,
})
export class ClassCategoryOpenSearchPipe implements PipeTransform {
  transform(value: CategoryOpenSearch) {
    for (const [key, val] of Object.entries(CategoryOpenSearch)) {
      if (Number(key) === value) {
        return CategoryOpenSearchClass[
          val as keyof typeof CategoryOpenSearchClass
        ].toLowerCase();
      }
    }

    return CategoryOpenSearchClass.ALL;
  }
}
